import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { ReviewCommissionsModel } from 'src/app/models/commission-summary/reviewcommissions.model';
import { ResponseData } from 'src/app/models/commission/response-data.model';
import { UpdateCommissionsUiModel } from 'src/app/models/commissionsummary/update-commissions-ui.model';
import { ReviewCommissionsService } from 'src/app/service/commission-summary/review-commissions.service';
import { NotificationService } from 'src/app/service/notification.service';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { NgForm } from '@angular/forms';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { MissingDisputesModel } from 'src/app/models/commission/missingdisputes.model';
import { MissingDisputesService } from 'src/app/service/missingdisputes.service';
import { WorkFlowMessageModel } from 'src/app/models/commissionsummary/workflowmessage.model';
import { CommissionSummaryService } from 'src/app/service/commission-summary.service';
import { Kpimaster } from 'src/app/models/commission/kpimaster.model';
import { CommPlanDetail } from 'src/app/models/commission/comm-plan-detail.model';
import { CommissionService } from 'src/app/service/commission.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { ApprovalFlowService } from 'src/app/admin-portal/approval-flow-models/approval-flow.service';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { getCurrencyInfo, applyCurrencySymbolOverride } from 'src/app/service/currency.util';

interface RcBreadcrumb {
  label: string;
  navIndex: number;
}

interface RcNavFrame {
  pageName: string;
  headerInfo: string;
  breadcrumbLabel: string;
  model: any;
  clickContext: {
    onClickedComplanId: number;
    onClickedScempid: string;
    onClickedCalrunid: string;
    salesRepId: string;
  };
}

@Component({
  selector: 'app-commissions-summary-get',
  templateUrl: './commissions-summary-get.component.html',
  styleUrls: ['./commissions-summary-get.component.css']
})
export class CommissionsSummaryGetComponent implements OnInit {

  private static disputeTrackIdCache = new Map<string, string>();

  public searchCriteriaSet = new Set<string>();
  public reviewCommissionsModel = new ReviewCommissionsModel();
  public missingDisputesModel = new MissingDisputesModel();
  public missingDisputesModel1 = new MissingDisputesModel();
  public workFlowMessageModel = new WorkFlowMessageModel();
  public addMissingDisputes = new MissingDisputesModel();

  public queryData: ReviewCommissionsModel[] = [];
  public mainResponse: ReviewCommissionsModel[] = [];
  public filteredData: ReviewCommissionsModel[] = [];
  public onClickData: ReviewCommissionsModel[] = [];
  public responseList: ResponseData[] = [];
  public headersData: UpdateCommissionsUiModel[];
  public filteredHeadersData: UpdateCommissionsUiModel[];
  public missingModels: MissingDisputesModel[] = [];
  public getImageData: CommPlanDetail[] = [];
  public searchDataList: ReviewCommissionsModel[] = [];
  public filterKPiData: Kpimaster[] = [];
  public kpis: Kpimaster[];
  public calcRunningStatus: UpdateCommissionsUiModel[];
  public disputeclosedata: UpdateCommissionsUiModel[] = [];

  public dataForExcel = [];
  public dataForExcelKeys = [];

  public contentMessage: WorkFlowMessageModel;
  public imgStr: SafeResourceUrl;

  public isCalcRunning: boolean = false;
  public firstTotalShown: boolean = false;
  public isExcelBtnDisabled: boolean = true;
  // public isdisputeview: boolean = false;
  public isDisputeBtnDisabled: boolean = false;
  public isCommPlanBtnDisabled: boolean = false;
  public showTeamDataCheckbox: boolean = false;
  public teamDataCheckedactive: boolean = false;
  public isFixedDisabled: boolean = true;
  public isMobileDisabled: boolean = false;
  public isNoDataFound: boolean = false;
  public showLoading: boolean;

  //public calcStatus: string;
  public str1: string = "";
  public str2: string = "";
  public pageName: string = "";
  public salesRepId: string = "";
  public showHideTds: any;
  public currentPageIndex: number = -1;
  public excelDataList: any;
  public extractedPageName: string;
  public selectedMIssingDisputeVal: string = "f";
  public vkpiid: string = "";
  public searchEmpParm: string = "";
  public selectedCalRunId: string = "";
  //public selectedCommPlanId: number = 0;
  public onClickedComplanId: number = 0;
  public onClickedScempid: string;
  public onClickedCalrunid: string;
  public disputeMsg: string;
  public effectiveDate: any;
  public view_dscempid: any;
  public view_dcorp: any;
  public view_dhouse: any;
  public view_dcust: any;
  public view_dtrackid: any;
  public view_dkomfeedid: any;
  public view_daccnum: any;
  public contentMsgData: any;
  public displayedData = [];
  public disputeViewData: string = "";
  public disputeViewKpiData: string = "";
  public displayedColumns: any;
  public kpiid: any = "";
  public dependent_kpiid: any = "";
  public final_kpiid: any = "";
  public sc_emp_id: any = "";
  public corp: any = "";
  public house: any = "";
  public cust: any = "";
  public kom_feed_id: any;
  public acc_num: any;
  public mobfeedid: any;
  public recordType: string = "";
  public compareDispute: any;
  public dscempid: any;
  public dcorp: any;
  public dhouse: any;
  public dcust: any;
  public dtrackid: any;
  public dkomffeedid: any;
  public daccnum: any;
  public isDisputeSubmitted: string = "true";
  public headerInfo: string = "";
  public breadcrumbTrail: RcBreadcrumb[] = [];

  private rootBreadcrumbLabel = "";
  private pendingBreadcrumbLabel: string | null = null;
  private restoredFromSession = false;
  private navigationStackRestored = false;
  private navFrames: RcNavFrame[] = [];
  private cachedByCustFeed: string | null = null;
  private cachedAccountNumber: number | null = null;
  private cachedSubscriberNumber: number | null = null;
  private lastPersistSignature = '';
  private readonly headerSelectionCache = new Map<string, UpdateCommissionsUiModel[]>();



  constructor(private reviewCommissionsService: ReviewCommissionsService, private notificationService: NotificationService, private _location: Location, private commissionService: CommissionService, private _sanitizer: DomSanitizer,
    private router: Router, private route: ActivatedRoute, public exportExcelService: ExportExcelService, private missingDisputesService: MissingDisputesService, private commissionSummaryService: CommissionSummaryService, private approvalFlowService: ApprovalFlowService,
    private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.refreshCustomerContextCache();
    const routePage = this.route.snapshot.queryParamMap.get('page');
    if (!this.restoreSessionState(routePage)) {
      this.router.navigate(['/commissions-summary-search']);
      return;
    }

    this.restoredFromSession = true;

    if (ReviewCommissionsService.isTopLevelPage(this.pageName) && !this.navigationStackRestored) {
      this.resetNavigationState();
    }

    this.syncRoutePageQueryParam();

    this.searchCriteriaSet = this.reviewCommissionsService.searchCriteriaSet;

    this.getRequiredData();

    this.missingDisputesModel.created_by = "";
    this.missingDisputesModel.created_dt = new Date();
    this.missingModels.push(this.missingDisputesModel);
  }

  private syncRoutePageQueryParam(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { page: this.pageName },
      replaceUrl: true,
    });
  }

  private restoreSessionState(routePage?: string | null): boolean {
    const searchParsed = this.parseStoredJson('SESSION_RC_SEARCH_MODEL');
    const drilldownParsed = this.parseStoredJson('SESSION_reviewCommissionsModel');
    const storedPageName = localStorage.getItem('SESSION_RC_PAGE_NAME');

    if (!searchParsed && !drilldownParsed) {
      return false;
    }

    this.pageName = (
      storedPageName
      || routePage
      || drilldownParsed?.pageName
      || searchParsed?.pageName
      || ''
    ).trim();

    if (ReviewCommissionsService.isTopLevelPage(this.pageName)) {
      this.reviewCommissionsModel = this.hydrateStoredModel(searchParsed || drilldownParsed);
      this.stripDrilldownFields(this.reviewCommissionsModel);
    } else {
      this.reviewCommissionsModel = this.hydrateStoredModel({
        ...(searchParsed || {}),
        ...(drilldownParsed || {}),
      });
    }

    this.applySessionFallbacks();

    this.rootBreadcrumbLabel = this.reviewCommissionsModel.selectedCommPlanHeader
      || localStorage.getItem('SESSION_RC_HEADER_INFO')
      || '';

    this.headerInfo = this.rootBreadcrumbLabel;

    if (!this.pageName && this.reviewCommissionsModel.pageName) {
      this.pageName = String(this.reviewCommissionsModel.pageName).trim();
    }
    this.pageName = this.applyResolvedPageName(this.pageName);
    if (ReviewCommissionsService.isInvalidPageName(this.pageName)) {
      localStorage.removeItem('SESSION_RC_RESOLVED_PAGE_NAME');
      if (ReviewCommissionsService.isInvalidPageName(localStorage.getItem('SESSION_RC_PAGE_NAME'))) {
        localStorage.removeItem('SESSION_RC_PAGE_NAME');
      }
      this.pageName = this.resolveTopLevelListPage();
    }

    this.reviewCommissionsModel.pageName = this.pageName;
    this.reviewCommissionsModel.selectedCommPlanHeader = this.headerInfo;
    this.reviewCommissionsService.reviewCommissionsModel = this.reviewCommissionsModel;

    this.restoreClickContext();
    this.restoreNavigationStack();
    this.hydrateBreadcrumbLabels();
    this.syncBreadcrumbs();
    this.teamDataCheckedactive = this.reviewCommissionsModel.teamDataCheckedactive === true;
    localStorage.setItem('level', this.teamDataCheckedactive ? '1' : '0');

    return this.hasValidRestoredSession();
  }

  navigateToBreadcrumb(navIndex: number): void {
    if (navIndex < 0) {
      this.router.navigate(['/commissions-summary-search']);
      return;
    }

    if (navIndex === this.currentPageIndex) {
      return;
    }

    while (this.currentPageIndex > navIndex) {
      this.mainResponse.pop();
      if (this.navFrames.length > 0) {
        this.navFrames.pop();
      }
      this.currentPageIndex--;
    }

    this.restoreNavFrame(this.currentPageIndex);
    this.updateResponseList();
    this.persistSessionState();
    this.syncRoutePageQueryParam();
    this.syncBreadcrumbs();
    this.applyListPageButtonState();
  }

  private buildDrilldownLabel(resData: any, targetPage: string): string {
    if (targetPage === 'ListKPIs') {
      return resData.empname || 'List KPIs';
    }
    if (targetPage === 'FindByKpi') {
      return resData.kpiname || resData.display_name || 'KPI Detail';
    }
    if (targetPage === 'GetKpiByCust') {
      return resData.cust_name || `${resData.corp}-${resData.house}-${resData.cust}`;
    }
    if (targetPage === 'GetCorpHouseCustByKpi' || targetPage === 'GetMobileLinesByKpi') {
      return resData.kpiname || resData.display_name || targetPage;
    }
    if (targetPage === 'GetCorpHouseCustList') {
      return `${resData.corp}-${resData.house}-${resData.cust}`;
    }
    if (targetPage === 'GetSupDetailsList') {
      return resData.cust_name || 'Supervisor Details';
    }
    return this.formatPageLabel(targetPage);
  }

  private formatPageLabel(pageName: string): string {
    const labels: Record<string, string> = {
      ListUsers: 'List Users',
      ListUsersByCustomer: 'List Customers',
      ListKPIs: 'List KPIs',
      FindByKpi: 'KPI Detail',
    };
    return labels[pageName] || pageName;
  }

  private syncBreadcrumbs(): void {
    const trail: RcBreadcrumb[] = [];

    for (let i = 0; i <= this.currentPageIndex && i < this.navFrames.length; i++) {
      const frame = this.navFrames[i];
      const label = frame?.breadcrumbLabel?.trim();
      if (frame && label) {
        trail.push({ label, navIndex: i });
      }
    }

    if (!trail.length && this.rootBreadcrumbLabel) {
      trail.push({ label: this.rootBreadcrumbLabel, navIndex: Math.max(this.currentPageIndex, 0) });
    }

    this.breadcrumbTrail = trail;
    this.headerInfo = trail.map((crumb) => crumb.label).join(' > ');
  }

  private hydrateBreadcrumbLabels(): void {
    if (this.navFrames.some((frame) => frame?.breadcrumbLabel?.trim())) {
      return;
    }

    const parts = (this.headerInfo || this.rootBreadcrumbLabel || '')
      .split('>')
      .map((part) => part.trim())
      .filter(Boolean);

    if (!parts.length) {
      return;
    }

    const frameCount = this.navFrames.filter(Boolean).length;
    const start = Math.max(0, parts.length - frameCount);

    this.navFrames.forEach((frame, index) => {
      if (!frame) {
        return;
      }
      const label = parts[start + index] || parts[parts.length - 1];
      frame.breadcrumbLabel = label;
    });
  }

  private restoreNavigationStack(): void {
    const mainRaw = localStorage.getItem('SESSION_RC_MAIN_RESPONSE');
    const idxRaw = localStorage.getItem('SESSION_RC_CURRENT_PAGE_INDEX');
    if (!mainRaw || idxRaw == null) {
      return;
    }

    try {
      this.mainResponse = JSON.parse(mainRaw);
      this.currentPageIndex = parseInt(idxRaw, 10);
      const framesRaw = localStorage.getItem('SESSION_RC_NAV_FRAMES');
      this.navFrames = framesRaw ? JSON.parse(framesRaw) : [];

      if (this.mainResponse.length > 0 && this.currentPageIndex >= 0) {
        if (this.currentPageIndex >= this.mainResponse.length) {
          this.currentPageIndex = this.mainResponse.length - 1;
        }
        this.cacheResolvedPageNameFromResponse(this.mainResponse[this.currentPageIndex]);
        this.navigationStackRestored = true;
        this.restoreNavFrame(this.currentPageIndex);
      }
    } catch {
      this.mainResponse = [];
      this.currentPageIndex = -1;
      this.navFrames = [];
      this.navigationStackRestored = false;
    }
  }

  private captureNavFrame(index: number): void {
    const label = this.pendingBreadcrumbLabel
      ?? (index === 0
        ? (this.rootBreadcrumbLabel || this.formatPageLabel(this.pageName))
        : this.formatPageLabel(this.pageName));
    this.pendingBreadcrumbLabel = null;

    const frame: RcNavFrame = {
      pageName: this.pageName,
      headerInfo: '',
      breadcrumbLabel: label,
      model: JSON.parse(JSON.stringify(this.reviewCommissionsModel)),
      clickContext: {
        onClickedComplanId: this.onClickedComplanId,
        onClickedScempid: this.onClickedScempid,
        onClickedCalrunid: this.onClickedCalrunid,
        salesRepId: this.salesRepId,
      },
    };
    this.navFrames[index] = frame;
    this.syncBreadcrumbs();
    this.navFrames[index].headerInfo = this.headerInfo;
  }

  private resolvePageName(): string {
    let pageName = (
      this.pageName
      || this.reviewCommissionsModel?.pageName
      || localStorage.getItem('SESSION_RC_PAGE_NAME')
      || this.route.snapshot.queryParamMap.get('page')
      || ''
    ).trim();
    return this.applyResolvedPageName(pageName);
  }

  private applyResolvedPageName(pageName: string): string {
    if (ReviewCommissionsService.isInvalidPageName(pageName)) {
      return pageName;
    }
    if (pageName !== 'FindByKpi') {
      return pageName;
    }
    const resolved = localStorage.getItem('SESSION_RC_RESOLVED_PAGE_NAME')?.trim();
    if (resolved && resolved !== 'FindByKpi' && !ReviewCommissionsService.isInvalidPageName(resolved)) {
      return resolved;
    }
    if (ReviewCommissionsService.isInvalidPageName(resolved)) {
      localStorage.removeItem('SESSION_RC_RESOLVED_PAGE_NAME');
    }
    return pageName;
  }

  private resolveKpiIdForDrilldown(resData: any, gridName: string): number {
    const isDependentGrid = gridName === 'Dependent Kpis' || gridName === 'Web Assist Dependent Kpis';
    if (isDependentGrid && resData.dpndnt_kpi_id != null && resData.dpndnt_kpi_id !== '') {
      return Number(resData.dpndnt_kpi_id);
    }
    return Number(resData.kpi_id);
  }

  private executeDrilldownQuery(): void {
    this.runQuery();
    this.getActiveKpis();
  }

  private validateKpiDrilldownBeforeQuery(resData: any, gridName: string): void {
    const kpiId = this.resolveKpiIdForDrilldown(resData, gridName);
    const commPlanId = Number(resData.comm_plan_id);
    if (!kpiId || !commPlanId) {
      this.executeDrilldownQuery();
      return;
    }

    this.commissionSummaryService.getPageName(commPlanId, kpiId).subscribe(
      (response) => {
        const feedType = (response?.[0]?.pageName || '').trim();
        const kpiType = response?.[0]?.kpi_type;
        if (!feedType || feedType === 'No Page') {
          this.notificationService.sendNotification(NotificationType.WARNING, 'No Drill Downs Allocated');
          return;
        }

        let resolvedPage = ReviewCommissionsService.resolveFindByKpiTargetPage(
          feedType,
          kpiType,
          gridName
        );

        if (ReviewCommissionsService.isInvalidPageName(resolvedPage)) {
          // Unknown feed on the client map — defer to backend getFinalPageName (c_review_comms_navigations).
          resolvedPage = 'FindByKpi';
        }

        this.pageName = resolvedPage;
        this.reviewCommissionsModel.pageName = resolvedPage;
        localStorage.setItem('SESSION_RC_PAGE_NAME', resolvedPage);
        localStorage.removeItem('SESSION_RC_RESOLVED_PAGE_NAME');
        this.syncRoutePageQueryParam();
        this.executeDrilldownQuery();
      },
      (errorResponse: HttpErrorResponse) => {
        this.notificationService.sendNotification(
          NotificationType.ERROR,
          ReviewCommissionsService.extractHttpErrorMessage(errorResponse, 'Unable to resolve KPI drilldown')
        );
      }
    );
  }

  private resolveRunQueryPageName(): string {
    const activePage = (this.pageName || '').trim();
    if (activePage) {
      return activePage === 'FindByKpi' ? this.applyResolvedPageName(activePage) : activePage;
    }
    const modelPage = (this.reviewCommissionsModel?.pageName || '').trim();
    if (modelPage) {
      return modelPage === 'FindByKpi' ? this.applyResolvedPageName(modelPage) : modelPage;
    }
    return this.resolvePageName();
  }

  private trimForwardStack(): void {
    while (this.mainResponse.length > this.currentPageIndex + 1) {
      this.mainResponse.pop();
    }
    while (this.navFrames.length > this.currentPageIndex + 1) {
      this.navFrames.pop();
    }
  }

  private extractResolvedPageName(response: any): string | null {
    const keys = Object.keys(response || {});
    if (!keys.length) {
      return null;
    }
    const parts = keys[0].split('_');
    return parts.length > 1 ? parts[1] : null;
  }

  private persistResolvedPageName(response: any): void {
    const resolved = this.extractResolvedPageName(response);
    if (!resolved || resolved === 'No Page') {
      return;
    }

    if (ReviewCommissionsService.isTopLevelPage(this.pageName)
        && !ReviewCommissionsService.isTopLevelPage(resolved)) {
      return;
    }

    localStorage.setItem('SESSION_RC_RESOLVED_PAGE_NAME', resolved);
    if (this.pageName === 'FindByKpi' || resolved !== this.pageName) {
      this.pageName = resolved;
      this.reviewCommissionsModel.pageName = resolved;
      localStorage.setItem('SESSION_RC_PAGE_NAME', resolved);
      this.syncRoutePageQueryParam();
    }
  }

  private syncQueryModelFields(): void {
    const model = this.reviewCommissionsModel;
    const dependentId = model.dependentKpiId ?? model.dpndnt_kpi_id;
    if (dependentId != null && dependentId !== 0) {
      model.dependentKpiId = Number(dependentId);
      model.dpndnt_kpi_id = model.dependentKpiId;
    }
  }

  private cacheResolvedPageNameFromResponse(response: any): void {
    if (!response || localStorage.getItem('SESSION_RC_RESOLVED_PAGE_NAME')) {
      return;
    }
    const resolved = this.extractResolvedPageName(response);
    if (resolved && resolved !== 'No Page') {
      localStorage.setItem('SESSION_RC_RESOLVED_PAGE_NAME', resolved);
    }
  }

  private restoreNavFrame(index: number): void {
    const frame = this.navFrames[index];
    if (!frame) {
      return;
    }

    this.pageName = frame.pageName || frame.model?.pageName || this.resolvePageName();
    this.reviewCommissionsModel = this.hydrateStoredModel(frame.model);
    this.reviewCommissionsModel.pageName = this.pageName;
    this.syncPayrollCalendarDates();
    this.reviewCommissionsService.reviewCommissionsModel = this.reviewCommissionsModel;

    if (frame.clickContext) {
      this.onClickedComplanId = frame.clickContext.onClickedComplanId ?? 0;
      this.onClickedScempid = frame.clickContext.onClickedScempid;
      this.onClickedCalrunid = frame.clickContext.onClickedCalrunid;
      this.salesRepId = frame.clickContext.salesRepId ?? '';
    }

    this.applyListPageButtonState();
    this.syncBreadcrumbs();
    this.reviewCommissionsModel.selectedCommPlanHeader = this.headerInfo;
  }

  private applyListPageButtonState(): void {
    if (this.pageName === 'ListUsers' || this.pageName === 'ListUsersByCustomer') {
      this.isDisputeBtnDisabled = false;
      this.isCommPlanBtnDisabled = false;
    } else if (this.pageName === 'ListKPIs') {
      this.isCommPlanBtnDisabled = true;
    } else {
      this.isCommPlanBtnDisabled = false;
    }
    this.updateTeamDataCheckboxVisibility();
  }

  private updateTeamDataCheckboxVisibility(): void {
    const isSupervisor = ReviewCommissionsService.isSupervisorRole(
      localStorage.getItem('CURRENT_USERROLE_SESSION')
    );
    this.showTeamDataCheckbox = isSupervisor;
    this.teamDataCheckedactive = this.reviewCommissionsModel.teamDataCheckedactive === true;
  }

  private resolveTopLevelListPage(): string {
    const storedRootPage = (localStorage.getItem('SESSION_RC_ROOT_LIST_PAGE') || '').trim();
    if (ReviewCommissionsService.isTopLevelPage(storedRootPage)) {
      return storedRootPage;
    }

    const searchModel = this.parseStoredJson('SESSION_RC_SEARCH_MODEL');
    const searchPage = (searchModel?.pageName || '').trim();
    if (ReviewCommissionsService.isTopLevelPage(searchPage)) {
      return searchPage;
    }

    const rootFramePage = this.navFrames[0]?.pageName;
    if (rootFramePage && ReviewCommissionsService.isTopLevelPage(rootFramePage)) {
      return rootFramePage;
    }

    return 'ListUsers';
  }

  private restoreSearchCriteriaFromSession(model: ReviewCommissionsModel): void {
    const searchParsed = this.parseStoredJson('SESSION_RC_SEARCH_MODEL');
    if (!searchParsed) {
      return;
    }

    if (searchParsed.commissionPlanId?.length) {
      model.commissionPlanId = searchParsed.commissionPlanId;
    }
    if (searchParsed.salesChannel) {
      model.salesChannel = searchParsed.salesChannel;
    }
  }

  private resetToTopLevelListForTeamToggle(listPage: string): void {
    const teamFlag = this.teamDataCheckedactive;

    this.restoreSearchCriteriaFromSession(this.reviewCommissionsModel);
    this.reviewCommissionsModel.teamDataCheckedactive = teamFlag;
    this.pageName = listPage;
    this.reviewCommissionsModel.pageName = listPage;
    this.headerInfo = this.rootBreadcrumbLabel;
    this.reviewCommissionsModel.selectedCommPlanHeader = this.headerInfo;
    this.stripDrilldownFields(this.reviewCommissionsModel);
    this.reviewCommissionsModel.firstName = null;
    this.reviewCommissionsModel.lastName = null;
    this.reviewCommissionsModel.sales_rep_id = null;
    this.reviewCommissionsModel.selectedPageName = null;
    this.reviewCommissionsModel.selectedGridName = null;
    this.reviewCommissionsModel.queryIdx = null;

    this.onClickedScempid = undefined;
    this.onClickedCalrunid = undefined;
    this.onClickedComplanId = 0;
    this.salesRepId = '';
    this.searchEmpParm = '';
    this.onClickData = [];
    this.responseList = [];
    this.pendingBreadcrumbLabel = null;
    this.reviewCommissionsService.reviewCommissionsModel = this.reviewCommissionsModel;

    localStorage.removeItem('SESSION_RC_CLICK_CONTEXT');
    localStorage.removeItem('SESSION_RC_RESOLVED_PAGE_NAME');
    localStorage.setItem('SESSION_RC_PAGE_NAME', listPage);

    this.syncRoutePageQueryParam();
  }

  public checkedVal(value: any): void {
    this.teamDataCheckedactive = !!value.currentTarget.checked;
    this.reviewCommissionsModel.teamDataCheckedactive = this.teamDataCheckedactive;
    localStorage.setItem('level', this.teamDataCheckedactive ? '1' : '0');

    const listPage = this.resolveTopLevelListPage();
    this.resetToTopLevelListForTeamToggle(listPage);
    this.resetNavigationState();
    this.syncBreadcrumbs();
    this.persistSessionState(true);
    this.runQuery(listPage);
  }

  private persistNavigationStack(): void {
    try {
      localStorage.setItem('SESSION_RC_MAIN_RESPONSE', JSON.stringify(this.mainResponse));
      localStorage.setItem('SESSION_RC_CURRENT_PAGE_INDEX', String(this.currentPageIndex));
      localStorage.setItem('SESSION_RC_NAV_FRAMES', JSON.stringify(this.navFrames));
    } catch {
      localStorage.removeItem('SESSION_RC_MAIN_RESPONSE');
      localStorage.removeItem('SESSION_RC_CURRENT_PAGE_INDEX');
      localStorage.removeItem('SESSION_RC_NAV_FRAMES');
    }
  }

  private parseStoredJson(key: string): any | null {
    const raw = localStorage.getItem(key);
    if (!raw) {
      return null;
    }
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  private hydrateStoredModel(parsed: any): ReviewCommissionsModel {
    const model = Object.assign(new ReviewCommissionsModel(), parsed);
    const validFromDt = ReviewCommissionsService.toDate(parsed?.validFromDt);
    const validToDt = ReviewCommissionsService.toDate(parsed?.validToDt);
    if (validFromDt) {
      model.validFromDt = validFromDt;
    }
    if (validToDt) {
      model.validToDt = validToDt;
    }
    const effectiveDate = ReviewCommissionsService.toDate(parsed?.effectiveDate);
    if (effectiveDate) {
      model.effectiveDate = effectiveDate;
    }
    return model;
  }

  private stripDrilldownFields(model: ReviewCommissionsModel): void {
    model.kpi_id = null;
    model.dependentKpiId = null;
    model.dpndnt_kpi_id = null;
    model.corp = null;
    model.house = null;
    model.cust = null;
    model.account_number = null;
    model.subscriber_number = null;
    model.kom_feed_id = null;
    model.mob_feed_id = null;
    model.grid_name = null;
    model.sc_emp_id = null;
    model.scEmpID = null;
    model.dependentScempid = null;
  }

  private restoreClickContext(): void {
    const raw = localStorage.getItem('SESSION_RC_CLICK_CONTEXT');
    if (raw) {
      try {
        const ctx = JSON.parse(raw);
        this.onClickedComplanId = ctx.onClickedComplanId ?? 0;
        this.onClickedScempid = ctx.onClickedScempid;
        this.onClickedCalrunid = ctx.onClickedCalrunid;
        this.salesRepId = ctx.salesRepId ?? '';
        return;
      } catch {
        // fall through to model defaults
      }
    }

    this.onClickedComplanId = this.reviewCommissionsModel.comm_plan_id
      || this.reviewCommissionsModel.commissionPlanId?.[0]
      || 0;
    this.onClickedScempid = this.reviewCommissionsModel.scEmpID || this.reviewCommissionsModel.sc_emp_id;
    this.onClickedCalrunid = this.reviewCommissionsModel.calRunId;
    this.salesRepId = this.reviewCommissionsModel.sales_rep_id || this.salesRepId || '';
  }

  private hasValidRestoredSession(): boolean {
    if (!this.pageName) {
      return false;
    }
    const m = this.reviewCommissionsModel;
    if (!this.hasSearchValue(m.calRunId)) {
      return false;
    }
    return this.hasSearchValue(m.salesChannel) ||
      this.hasSearchValue(m.commissionPlanId) ||
      this.hasSearchValue(m.firstName) ||
      this.hasSearchValue(m.lastName) ||
      this.hasSearchValue(m.scEmpID) ||
      this.hasSearchValue(m.employeeId) ||
      this.hasSearchValue(m.sales_rep_id);
  }

  private hasSearchValue(value: any): boolean {
    if (Array.isArray(value)) {
      return value.length > 0;
    }
    if (value == null) {
      return false;
    }
    const normalized = String(value).trim().toLowerCase();
    return normalized !== '' && normalized !== 'null';
  }

  private resetNavigationState(): void {
    this.mainResponse = [];
    this.responseList = [];
    this.currentPageIndex = -1;
    this.navFrames = [];
    this.navigationStackRestored = false;
    this.isNoDataFound = false;
  }

  private getHeaderCommPlanId(): number {
    const commPlanIds = this.reviewCommissionsModel.commissionPlanId;
    if (commPlanIds == null) {
      return 0;
    }
    const ids = Array.isArray(commPlanIds) ? commPlanIds : [commPlanIds];
    if (ids.length > 1) {
      return 0;
    }
    return ids[0] ?? 0;
  }

  private applySessionFallbacks(): void {
    if (!this.reviewCommissionsModel.salesChannel) {
      this.reviewCommissionsModel.salesChannel = localStorage.getItem('SESSION_SC');
    }
    if (!this.reviewCommissionsModel.country) {
      this.reviewCommissionsModel.country = localStorage.getItem('country');
    }
    if (!this.reviewCommissionsModel.calRunId) {
      this.reviewCommissionsModel.calRunId = localStorage.getItem('SESSION_CALRUNID');
    }
    if (!this.reviewCommissionsModel.commissionPlanId?.length && localStorage.getItem('SESSION_COMMPLAN')) {
      try {
        this.reviewCommissionsModel.commissionPlanId = JSON.parse(localStorage.getItem('SESSION_COMMPLAN'));
      } catch {
        // ignore invalid stored commission plan
      }
    }
    if (!this.reviewCommissionsModel.validFromDt) {
      const storedFrom = ReviewCommissionsService.toDate(localStorage.getItem('validFromDt'));
      if (storedFrom) {
        this.reviewCommissionsModel.validFromDt = storedFrom;
      }
    }
    if (!this.reviewCommissionsModel.validToDt) {
      const storedTo = ReviewCommissionsService.toDate(localStorage.getItem('validToDt'));
      if (storedTo) {
        this.reviewCommissionsModel.validToDt = storedTo;
      }
    }
    this.syncPayrollCalendarDates();
  }

  /** GetCorpHouseCustList and similar pages filter on comm-period dates; repair invalid ranges before query. */
  private syncPayrollCalendarDates(): void {
    const currentFrom = ReviewCommissionsService.toDate(this.reviewCommissionsModel.validFromDt);
    const currentTo = ReviewCommissionsService.toDate(this.reviewCommissionsModel.validToDt);
    if (ReviewCommissionsService.isValidPayrollDateRange(currentFrom, currentTo)) {
      return;
    }

    const resolved = this.reviewCommissionsService.resolvePayrollCalendarDates(
      this.reviewCommissionsModel.calRunId,
      this.reviewCommissionsModel.commissionPlanId
    );
    if (!ReviewCommissionsService.isValidPayrollDateRange(resolved.validFromDt, resolved.validToDt)) {
      return;
    }

    this.reviewCommissionsModel.validFromDt = resolved.validFromDt!;
    this.reviewCommissionsModel.validToDt = resolved.validToDt!;
    localStorage.setItem('validFromDt', ReviewCommissionsService.toStoredDateValue(resolved.validFromDt));
    localStorage.setItem('validToDt', ReviewCommissionsService.toStoredDateValue(resolved.validToDt));
  }

  private persistSessionState(force = false): void {
    this.reviewCommissionsModel.pageName = this.pageName;
    this.reviewCommissionsModel.selectedCommPlanHeader = this.headerInfo;
    this.reviewCommissionsService.reviewCommissionsModel = this.reviewCommissionsModel;
    const signature = this.buildPersistSignature();
    if (!force && signature === this.lastPersistSignature) {
      return;
    }
    this.lastPersistSignature = signature;
    localStorage.setItem('SESSION_reviewCommissionsModel', JSON.stringify(this.reviewCommissionsModel));
    localStorage.setItem('SESSION_RC_PAGE_NAME', this.pageName ?? '');
    localStorage.setItem('SESSION_RC_HEADER_INFO', this.headerInfo ?? '');
    localStorage.setItem('SESSION_RC_CLICK_CONTEXT', JSON.stringify({
      onClickedComplanId: this.onClickedComplanId,
      onClickedScempid: this.onClickedScempid,
      onClickedCalrunid: this.onClickedCalrunid,
      salesRepId: this.salesRepId,
    }));
    this.persistNavigationStack();
  }

  private buildPersistSignature(): string {
    return [
      this.pageName ?? '',
      this.headerInfo ?? '',
      this.currentPageIndex,
      this.mainResponse.length,
      this.navFrames.length,
      this.onClickedComplanId ?? 0,
      this.onClickedScempid ?? '',
      this.onClickedCalrunid ?? '',
      this.salesRepId ?? '',
      this.reviewCommissionsModel?.calRunId ?? '',
      this.reviewCommissionsModel?.salesChannel ?? '',
      JSON.stringify(this.reviewCommissionsModel?.commissionPlanId ?? []),
      this.reviewCommissionsModel?.pageName ?? '',
      String(this.reviewCommissionsModel?.teamDataCheckedactive === true)
    ].join('|');
  }

  private getHeaderSelection(finalConfigId: string, salesChannel: string, commPlanId: number): UpdateCommissionsUiModel[] {
    const cacheKey = `${finalConfigId}|${salesChannel}|${commPlanId}`;
    const cached = this.headerSelectionCache.get(cacheKey);
    if (cached) {
      return cached;
    }

    const selected = this.headersData.filter(item =>
      String(item.configid) === finalConfigId &&
      item.header_saleschannel === salesChannel &&
      item.header_commplanid === commPlanId
    );
    this.headerSelectionCache.set(cacheKey, selected);
    return selected;
  }



  getRequiredData() {
    this.reviewCommissionsService.fetchHeaders().subscribe(
      (response: UpdateCommissionsUiModel[]) => {
        this.headersData = response || [];
        this.headerSelectionCache.clear();
        if (this.navigationStackRestored) {
          this.updateResponseList();
          if (this.restoredFromSession && this.onClickedComplanId) {
            this.getActiveKpis();
            this.restoredFromSession = false;
          }
        } else {
          this.pageName = this.resolvePageName();
          this.reviewCommissionsModel.pageName = this.pageName;
          this.runQuery();
        }
      }, (errorResponse: HttpErrorResponse) => {
        this.notificationService.sendNotification(
          NotificationType.ERROR,
          ReviewCommissionsService.extractHttpErrorMessage(errorResponse, 'Unable to load headers')
        );
        this.showLoading = false;
      });
  }

  // Back button logic
  public onBackClick(steps: number = 1, stat: number) {
    const newIndex = this.currentPageIndex - steps;
    this.currentPageIndex = Math.max(newIndex, 0);

    this.mainResponse.pop();
    if (this.navFrames.length > 0) {
      this.navFrames.pop();
    }

    if (stat === 1) {
      return;
    }

    if (newIndex < 0) {
      this.router.navigate(['/commissions-summary-search']);
    } else {
      this.restoreNavFrame(this.currentPageIndex);
      this.updateResponseList();
      this.persistSessionState();
      this.syncRoutePageQueryParam();
    }

    this.applyListPageButtonState();
    this.syncBreadcrumbs();
  }

  /** Header hyperlink flag + optional SQL row flag (ishyperlink) — KPI rules live in CommsUI SQL. */
  isRowHyperlinkEnabled(row: any, header: any): boolean {
    return this.isFlagEnabled(header?.ishyperlinkview)
      && ReviewCommissionsService.isSqlRowHyperlinkAllowed(row);
  }

  public onClickHyperLink(resData: any, pageNav: string, configid: number, grid_name: string) {
    if (!ReviewCommissionsService.isSqlRowHyperlinkAllowed(resData)) {
      return;
    }

    this.responseList = [];
    localStorage.removeItem('SESSION_RC_RESOLVED_PAGE_NAME');

    let targetPage = pageNav;
    if (pageNav === 'GetCorpHouseCustByKpi') {
      targetPage = this.isKomCustomerFeed(resData) ? 'GetCorpHouseCustByKpi' : 'GetMobileLinesByKpi';
    }

    if (targetPage === 'GetMobileLinesByKpi' && !this.hasMobileLineDrilldownContext(resData)) {
      this.notificationService.sendNotification(
        NotificationType.WARNING,
        'Mobile line drilldown requires account number and subscriber number from the customer row.'
      );
      return;
    }

    if (targetPage === 'GetMobileLinesByKpi') {
      const mobileSalesRepId = resData.sales_rep_id || this.salesRepId || this.reviewCommissionsModel.sales_rep_id;
      if (!mobileSalesRepId) {
        this.notificationService.sendNotification(
          NotificationType.WARNING,
          'Mobile line drilldown requires sales rep id from the GetKpiByCust header row.'
        );
        return;
      }
    }

    const searchContext = {
      salesChannel: this.reviewCommissionsModel.salesChannel,
      calRunId: this.reviewCommissionsModel.calRunId,
      validFromDt: this.reviewCommissionsModel.validFromDt,
      validToDt: this.reviewCommissionsModel.validToDt,
      firstName: this.reviewCommissionsModel.firstName,
      lastName: this.reviewCommissionsModel.lastName,
      employeeId: this.reviewCommissionsModel.employeeId,
      scEmpID: resData.sc_emp_id || this.reviewCommissionsModel.scEmpID,
      sales_rep_id: resData.sales_rep_id || this.salesRepId || this.reviewCommissionsModel.sales_rep_id,
      teamDataCheckedactive: this.reviewCommissionsModel.teamDataCheckedactive,
      user_role: this.reviewCommissionsModel.user_role,
      loggedInEmpId: this.reviewCommissionsModel.loggedInEmpId
    };

    this.pageName = targetPage;
    this.syncRoutePageQueryParam();
    this.pendingBreadcrumbLabel = this.buildDrilldownLabel(resData, targetPage);

    if (targetPage === "GetKpiByCust") {
      if (resData.kom_feed_id) {
        localStorage.setItem('bycust_feed', 'kom');
        this.cachedByCustFeed = 'kom';
        this.cachedAccountNumber = null;
        this.cachedSubscriberNumber = null;
      } else {
        localStorage.setItem('bycust_feed', 'mob');
        this.cachedByCustFeed = 'mob';
        if (resData.account_number != null && resData.account_number !== '') {
          localStorage.setItem('acc2', ',' + resData.account_number);
          this.cachedAccountNumber = Number(resData.account_number);
        }
        if (resData.subscriber_number != null && resData.subscriber_number !== '') {
          localStorage.setItem('subno2', ',' + resData.subscriber_number);
          this.cachedSubscriberNumber = Number(resData.subscriber_number);
        }
      }
    }

    this.onClickedComplanId = resData.comm_plan_id;
    this.onClickedScempid = resData.sc_emp_id;
    this.onClickedCalrunid = this.reviewCommissionsModel.calRunId;

    this.onClickData[0] = resData;

    this.onClickData[0].validFromDt = this.reviewCommissionsModel.validFromDt;
    this.onClickData[0].validToDt = this.reviewCommissionsModel.validToDt;
    this.onClickData[0].salesChannel = this.reviewCommissionsModel.salesChannel;
    this.onClickData[0].calRunId = this.reviewCommissionsModel.calRunId;

    this.onClickData[0].scEmpID = resData.sc_emp_id || this.reviewCommissionsModel.scEmpID;
    this.onClickData[0].dependentScempid = resData.dpndnt_sc_emp_id;
    this.onClickData[0].kpi_id = resData.kpi_id;
    if (resData.dpndnt_kpi_id != null && resData.dpndnt_kpi_id !== '') {
      this.onClickData[0].dependentKpiId = Number(resData.dpndnt_kpi_id);
      this.onClickData[0].dpndnt_kpi_id = Number(resData.dpndnt_kpi_id);
    }
    this.onClickData[0].corp = resData.corp != null ? Number(resData.corp) : this.reviewCommissionsModel.corp;
    this.onClickData[0].house = resData.house ?? this.reviewCommissionsModel.house;
    this.onClickData[0].cust = resData.cust ?? this.reviewCommissionsModel.cust;
    this.onClickData[0].account_number = this.resolveAccountNumberFromContext(resData);
    this.onClickData[0].subscriber_number = this.resolveSubscriberNumberFromContext(resData);
    this.onClickData[0].kom_feed_id = resData.kom_feed_id ?? this.reviewCommissionsModel.kom_feed_id;
    this.onClickData[0].mob_feed_id = resData.mob_feed_id ?? this.reviewCommissionsModel.mob_feed_id;

    const resolvedSalesRepId = resData.sales_rep_id
      || this.salesRepId
      || this.reviewCommissionsModel.sales_rep_id
      || this.resolveDrilldownSalesRepId();
    if (resolvedSalesRepId) {
      this.salesRepId = resolvedSalesRepId;
      this.onClickData[0].sales_rep_id = resolvedSalesRepId;
    }

    this.onClickData[0].commissionPlanId = [];
    this.onClickData[0].commissionPlanId.push(resData.comm_plan_id);
    this.onClickData[0].pageName = targetPage;
    this.onClickData[0].grid_name = grid_name;

    this.reviewCommissionsModel = Object.assign(new ReviewCommissionsModel(), searchContext, this.onClickData[0]);
    this.reviewCommissionsModel.pageName = targetPage;
    this.reviewCommissionsModel.selectedCommPlanHeader = this.headerInfo;
    this.persistSessionState();

    if (targetPage === 'FindByKpi' && resData.kpi_id) {
      this.validateKpiDrilldownBeforeQuery(resData, grid_name);
    } else {
      this.executeDrilldownQuery();
    }

    this.reviewCommissionsService.searchDropdownCache
      .filter(item => item.commPlanId === resData.comm_plan_id)
      .forEach(jsonModel => {
      this.effectiveDate = jsonModel.effectiveDate;
      if (jsonModel.effectiveDate) {
        localStorage.setItem('SESSION_EFFDATE', String(jsonModel.effectiveDate));
      }
    });
  }

  runQuery(forcedPageName?: string) {
    this.applyListPageButtonState();

    this.queryData = null;

    if (forcedPageName) {
      this.pageName = forcedPageName;
      this.reviewCommissionsModel.pageName = forcedPageName;
      this.stripDrilldownFields(this.reviewCommissionsModel);
      localStorage.removeItem('SESSION_RC_RESOLVED_PAGE_NAME');
      localStorage.setItem('SESSION_RC_PAGE_NAME', forcedPageName);
    } else {
      this.pageName = this.resolveRunQueryPageName();
    }
    if (ReviewCommissionsService.isInvalidPageName(this.pageName)) {
      localStorage.removeItem('SESSION_RC_RESOLVED_PAGE_NAME');
      if (this.pageName === 'No Page') {
        this.notificationService.sendNotification(NotificationType.WARNING, 'No Drill Downs Allocated');
        return;
      }
      this.notificationService.sendNotification(
        NotificationType.ERROR,
        'Unable to determine page. Please search again.'
      );
      this.router.navigate(['/commissions-summary-search']);
      return;
    }

    this.applySessionFallbacks();
    this.reviewCommissionsModel.pageName = this.pageName;
    ReviewCommissionsService.applyRoleBasedSearchScope(this.reviewCommissionsModel);
    this.restoreDrilldownSalesRepIdForQuery();
    this.syncQueryModelFields();
    this.persistSessionState();

    console.log(this.reviewCommissionsModel);
    this.reviewCommissionsService.runQuery(this.reviewCommissionsModel).subscribe(
      (response: any) => {
        this.persistResolvedPageName(response);

        // Check if response contains ListKPIs
        const hasSamePageName = Object.keys(response).some(key => key.includes(this.pageName));

        if (hasSamePageName) {
          const existingIndex = this.mainResponse.findIndex(obj =>
            Object.keys(obj).some(key => key.includes(this.pageName))
          );

          if (existingIndex !== -1 && existingIndex === this.currentPageIndex) {
            this.mainResponse[existingIndex] = response;
            this.currentPageIndex = existingIndex;
          } else {
            this.trimForwardStack();
            this.mainResponse.push(response);
            this.currentPageIndex = this.mainResponse.length - 1;
          }
        } else {
          this.trimForwardStack();
          this.mainResponse.push(response);
          this.currentPageIndex = this.mainResponse.length - 1;
        }

        this.captureNavFrame(this.currentPageIndex);
        this.persistSessionState();

        this.updateResponseList();

        if (this.restoredFromSession && this.onClickedComplanId) {
          this.getActiveKpis();
          this.restoredFromSession = false;
        }

      },
      (errorResponse: HttpErrorResponse) => {
        const msg = ReviewCommissionsService.extractHttpErrorMessage(errorResponse);
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  // Refresh responseList from current page in mainResponse
  private updateResponseList() {

    if (this.currentPageIndex >= 0 && this.currentPageIndex < this.mainResponse.length) {

      const currentResponse = this.mainResponse[this.currentPageIndex];
      const builtItems: ResponseData[] = [];
      let disputeRows: ReviewCommissionsModel[] = [];
      this.isNoDataFound = false;

      Object.keys(currentResponse).forEach((queryKey: string, index: number) => {
        const result = this.processResponseKey(currentResponse, queryKey, index);
        if (!result) {
          return;
        }
        builtItems.push(result.data);
        if (result.disputeRows) {
          disputeRows.push(...result.disputeRows);
        }
      });

      this.responseList = builtItems;
      this.isNoDataFound = builtItems.length === 0;
      this.finishUpdateResponseList();

      if (disputeRows.length > 0) {
        this.enrichDisputeStatus(disputeRows).subscribe({
          next: () => this.changeDetectorRef.markForCheck(),
          error: () => this.changeDetectorRef.markForCheck(),
        });
      }

    }
  }

  private finishUpdateResponseList(): void {
    if (this.pageName === 'ListKPIs' && this.responseList.length > 0) {
      this.applyListKpisGrandTotal();
    }
  }

  private resolveTrackId(row: ReviewCommissionsModel): string | null {
    if (row.kom_feed_id) {
      return String(row.kom_feed_id);
    }
    if (row.mob_feed_id) {
      return String(row.mob_feed_id);
    }
    if (row.account_number) {
      return String(row.account_number);
    }
    if (row.corp != null && row.house != null && row.cust != null) {
      return row.corp + '-' + row.house + '-' + row.cust;
    }
    return null;
  }

  private toErrorMessage(error: any): string {
    if (typeof error === 'string') {
      return error;
    }
    if (error?.message) {
      return error.message;
    }
    return 'Unable to load dispute status';
  }

  private disputeSubmittedFromWorkflow(response: WorkFlowMessageModel[]): string {
    if (response.length > 0) {
      if (response[0].status === 'Rejected') {
        return 'true';
      }
      return 'false';
    }
    return 'true';
  }

  private enrichDisputeStatus(rows: ReviewCommissionsModel[]): Observable<void> {
    if (!rows || rows.length === 0) {
      return of(undefined);
    }

    const trackIdToRowIndices = new Map<string, number[]>();

    rows.forEach((row, index) => {
      const trackId = this.resolveTrackId(row);
      if (!trackId) {
        row.isDisputeSubmitted = 'true';
        return;
      }
      if (!trackIdToRowIndices.has(trackId)) {
        trackIdToRowIndices.set(trackId, []);
      }
      trackIdToRowIndices.get(trackId).push(index);
    });

    const uniqueTrackIds = Array.from(trackIdToRowIndices.keys());

    uniqueTrackIds.forEach((trackId) => {
      const cached = CommissionsSummaryGetComponent.disputeTrackIdCache.get(trackId);
      if (cached !== undefined) {
        trackIdToRowIndices.get(trackId).forEach((rowIndex) => {
          rows[rowIndex].isDisputeSubmitted = cached;
        });
      }
    });

    const uncachedTrackIds = uniqueTrackIds.filter(
      (trackId) => !CommissionsSummaryGetComponent.disputeTrackIdCache.has(trackId)
    );

    if (uncachedTrackIds.length === 0) {
      return of(undefined);
    }

    let disputeErrorNotified = false;
    const requests = uncachedTrackIds.map((trackId) =>
      this.commissionSummaryService.getTrackidCount(trackId).pipe(
        map((response: WorkFlowMessageModel[]) => ({
          trackId,
          isDisputeSubmitted: this.disputeSubmittedFromWorkflow(response),
        })),
        catchError((error: any) => {
          if (!disputeErrorNotified) {
            disputeErrorNotified = true;
            this.notificationService.sendNotification(NotificationType.ERROR, this.toErrorMessage(error));
            this.showLoading = false;
          }
          return of(null);
        })
      )
    );

    return forkJoin(requests).pipe(
      map((results) => {
        results.forEach((result) => {
          if (!result) {
            return;
          }
          CommissionsSummaryGetComponent.disputeTrackIdCache.set(result.trackId, result.isDisputeSubmitted);
          trackIdToRowIndices.get(result.trackId).forEach((rowIndex) => {
            rows[rowIndex].isDisputeSubmitted = result.isDisputeSubmitted;
          });
        });
      })
    );
  }

  private invalidateDisputeCacheForTrackId(trackId: string): void {
    if (trackId) {
      CommissionsSummaryGetComponent.disputeTrackIdCache.delete(trackId);
    }
  }

  private buildTrackIdFromDisputeModel(): string {
    let trackId = this.workFlowMessageModel.kom_feed_id;
    if (!trackId) {
      trackId = this.workFlowMessageModel.accnum;
    }
    if (!trackId) {
      trackId = this.workFlowMessageModel.corp + '-' + this.workFlowMessageModel.house + '-' + this.workFlowMessageModel.cust;
    }
    return trackId;
  }

  private applyListKpisGrandTotal(): void {
    const lastGrid = this.responseList[this.responseList.length - 1];
    if (!lastGrid) {
      return;
    }

    const headerSource = this.responseList.find((grid) => this.hasTotalRow(grid)) || lastGrid;
    if (!headerSource?.headers?.length) {
      return;
    }

    const allRows = this.responseList.reduce((rows: any[], grid: ResponseData) => {
      return rows.concat(grid.responsedata || []);
    }, []);

    const totalResult = this.calculateTotals(allRows, headerSource.headers);
    lastGrid.totals = totalResult.totals;
    lastGrid.showHideTds = totalResult.showHideTds;
  }

  private processResponseKey(response: any, queryKey: string, index: number): { data: ResponseData; disputeRows?: ReviewCommissionsModel[] } | null {
    const orgPageName = queryKey.split("_");
    this.extractedPageName = orgPageName[1];

    this.queryData = response[queryKey]; // array of rows for this query

    if (this.queryData.length === 0) {
      return null;
    }

    const disputeRows = this.resolveDisputeRows();
    const data = new ResponseData();
    data.responsedata = this.queryData;

    this.updateActionStates(this.queryData[0]);

    const cid = this.getHeaderCommPlanId();
    const finalConfigId = String(this.queryData[0].finalConfigId);
    const selectedSalesChannel = this.reviewCommissionsModel.salesChannel;

    if (!this.headersData?.length) {
      return { data, disputeRows };
    }

    this.filteredHeadersData = this.resolveHeadersForQuery(finalConfigId, selectedSalesChannel, cid);

    data.headers = this.filteredHeadersData.slice();
    this.applyDisputeHeaderView(
      data.headers,
      this.extractedPageName || this.pageName,
      this.resolveActiveCommPlanId()
    );
    const totalResult = this.calculateTotals(this.queryData, this.filteredHeadersData);
    data.totals = totalResult.totals;
    data.showHideTds = totalResult.showHideTds;

    if (this.pageName === 'GetKpiByCust') {
      this.captureGetKpiByCustHeaderContext(this.queryData);
    } else {
      this.captureSalesRepIdContext(this.queryData, this.pageName);
    }

    return { data, disputeRows };
  }

  private resolveActiveCommPlanId(): number {
    const fromSearch = this.getHeaderCommPlanId();
    if (fromSearch) {
      return fromSearch;
    }
    if (this.onClickedComplanId) {
      return this.onClickedComplanId;
    }
    const fromRow = Number(this.queryData?.[0]?.comm_plan_id);
    if (fromRow) {
      return fromRow;
    }
    return Number(this.reviewCommissionsModel?.comm_plan_id) || 0;
  }

  private resolveDisputeRows(): ReviewCommissionsModel[] | undefined {
    const page = (this.extractedPageName || this.pageName || '').trim();
    const commPlanId = this.resolveActiveCommPlanId();
    if (!ReviewCommissionsService.isPlanScopedDisputeDetailPage(page, commPlanId)) {
      return undefined;
    }
    this.compareDispute = this.queryData;
    return this.queryData;
  }

  /** Plan 114 Connect Revenue / Mobile Multi Lines until CommsUI headers set isdisputeview. */
  private applyDisputeHeaderView(
    headers: UpdateCommissionsUiModel[],
    pageName: string,
    commPlanId: number
  ): void {
    if (!headers?.length || !ReviewCommissionsService.isPlanScopedDisputeDetailPage(pageName, commPlanId)) {
      return;
    }
    headers[0].isdisputeview = true;
  }

  private updateActionStates(firstRow: any): void {
    if (this.pageName === "ListUsers" || this.pageName === "ListUsersByCustomer") {
      this.isDisputeBtnDisabled = false;
    } else {
      const disputeStatus = firstRow?.disputeCloseDateStatus
        ?? localStorage.getItem('SESSION_DISPUTE_CLOSE_STATUS');
      this.isDisputeBtnDisabled = disputeStatus === "valid";
    }
    this.isCalcRunning = firstRow?.calcRunStatus === "Running";
  }

  private resolveHeadersForQuery(finalConfigId: string, selectedSalesChannel: string, commPlanId: number): UpdateCommissionsUiModel[] {
    const configChannels = this.headersData
      .filter(item => String(item.configid) === finalConfigId)
      .map(item => (item.header_saleschannel || '').trim())
      .filter(sc => !!sc);
    const salesChannelsToTry = [...new Set([
      ...configChannels,
      (selectedSalesChannel || '').trim(),
      'Global'
    ].filter(sc => !!sc))];
    const commPlanIdsToTry = [...new Set([commPlanId, 0])];

    for (const sc of salesChannelsToTry) {
      for (const cp of commPlanIdsToTry) {
        const headers = this.getHeaderSelection(finalConfigId, sc, cp);
        if (headers.length > 0) {
          return headers.slice().sort((a, b) => (Number(a.colorder) || 0) - (Number(b.colorder) || 0));
        }
      }
    }
    return [];
  }

  /** KOM vs mobile feed: prefer row/model kom_feed_id over stale localStorage. */
  private isKomCustomerFeed(resData: any): boolean {
    if (resData?.kom_feed_id) {
      return true;
    }
    if (this.reviewCommissionsModel?.kom_feed_id) {
      return true;
    }
    return this.cachedByCustFeed === 'kom';
  }

  private hasMobileLineDrilldownContext(resData: any): boolean {
    return this.resolveAccountNumberFromContext(resData) != null
      && this.resolveSubscriberNumberFromContext(resData) != null;
  }

  private resolveAccountNumberFromContext(resData: any): number | null {
    const raw = resData?.account_number ?? this.reviewCommissionsModel?.account_number;
    if (raw != null && raw !== '') {
      const parsed = Number(raw);
      return Number.isNaN(parsed) ? null : parsed;
    }
    return this.cachedAccountNumber;
  }

  private resolveSubscriberNumberFromContext(resData: any): number | null {
    const raw = resData?.subscriber_number ?? this.reviewCommissionsModel?.subscriber_number;
    if (raw != null && raw !== '') {
      const parsed = Number(raw);
      return Number.isNaN(parsed) ? null : parsed;
    }
    return this.cachedSubscriberNumber;
  }

  private refreshCustomerContextCache(): void {
    this.cachedByCustFeed = localStorage.getItem('bycust_feed');
    this.cachedAccountNumber = this.parseStoredNumber('acc2');
    this.cachedSubscriberNumber = this.parseStoredNumber('subno2');
  }

  private parseStoredNumber(key: string): number | null {
    const raw = localStorage.getItem(key);
    if (!raw) {
      return null;
    }
    const parsed = Number(String(raw).replace(/^,/, ''));
    return Number.isNaN(parsed) ? null : parsed;
  }

  /**
   * Legacy Review Commissions keeps searchSalesRepIdParm across drilldowns; role scope on the new page
   * clears sales_rep_id before query. Restore it for corp/house/cust drilldowns for rep/supervisor logins.
   */
  private restoreDrilldownSalesRepIdForQuery(): void {
    if (!ReviewCommissionsService.requiresDrilldownSalesRepId(this.pageName)) {
      return;
    }

    const role = localStorage.getItem('CURRENT_USERROLE_SESSION');
    const isRepOrSupervisor = ReviewCommissionsService.isSalesRepresentativeRole(role)
      || ReviewCommissionsService.isSupervisorRole(role)
      || ReviewCommissionsService.isSalesChannelAdminRole(role);
    if (!isRepOrSupervisor) {
      return;
    }

    const resolved = this.resolveDrilldownSalesRepId();
    if (resolved) {
      this.applySalesRepId(resolved);
    }
  }

  private resolveDrilldownSalesRepId(): string | null {
    const candidates = [
      this.salesRepId,
      this.reviewCommissionsModel.sales_rep_id,
      localStorage.getItem('SESSION_REPID'),
      this.findSalesRepIdInNavFrames(),
      this.findSalesRepIdInMainResponse(),
    ];

    for (const candidate of candidates) {
      const normalized = ReviewCommissionsService.normalizeSalesRepId(candidate);
      if (normalized) {
        return normalized;
      }
    }
    return null;
  }

  private findSalesRepIdInNavFrames(): string | null {
    for (let index = this.navFrames.length - 1; index >= 0; index--) {
      const salesRepId = this.navFrames[index]?.clickContext?.salesRepId;
      const normalized = ReviewCommissionsService.normalizeSalesRepId(salesRepId);
      if (normalized) {
        return normalized;
      }
    }
    return null;
  }

  private findSalesRepIdInMainResponse(): string | null {
    for (let index = this.mainResponse.length - 1; index >= 0; index--) {
      const response = this.mainResponse[index];
      for (const key of Object.keys(response || {})) {
        const rows = response[key];
        if (!Array.isArray(rows)) {
          continue;
        }
        for (const row of rows) {
          const normalized = ReviewCommissionsService.normalizeSalesRepId(row?.sales_rep_id);
          if (normalized) {
            return normalized;
          }
        }
      }
    }
    return null;
  }

  private applySalesRepId(value: unknown): void {
    const normalized = ReviewCommissionsService.normalizeSalesRepId(value);
    if (!normalized) {
      return;
    }
    this.salesRepId = normalized;
    this.reviewCommissionsModel.sales_rep_id = normalized;
  }

  private captureSalesRepIdContext(rows: any[], sourcePage?: string): void {
    if (!rows?.length) {
      return;
    }

    const headerRow = rows.find(row =>
      ReviewCommissionsService.normalizeSalesRepId(row?.sales_rep_id) && row?.valid_from_dt && !row?.kpi_id
    );
    if (headerRow?.sales_rep_id) {
      this.applySalesRepId(headerRow.sales_rep_id);
      return;
    }

    if (sourcePage === 'ListKPIs' || sourcePage === 'ListUsers' || sourcePage === 'ListUsersByCustomer') {
      const listRow = rows.find(row => ReviewCommissionsService.normalizeSalesRepId(row?.sales_rep_id));
      if (listRow?.sales_rep_id) {
        this.applySalesRepId(listRow.sales_rep_id);
      }
    }
  }

  /** GetCorpHouseCustByKpi needs sales_rep_id and comm-period dates from the header grid (config 38). */
  private captureGetKpiByCustHeaderContext(rows: any[]): void {
    if (!rows?.length) {
      return;
    }

    const row = rows[0];
    const configId = String(row.finalConfigId ?? '');
    const isHeaderGrid = configId === '38' || (!row.kpi_id && row.sales_rep_id && row.valid_from_dt);
    if (!isHeaderGrid) {
      return;
    }

    if (row.sales_rep_id) {
      this.applySalesRepId(row.sales_rep_id);
    }
    if (row.valid_from_dt) {
      this.reviewCommissionsModel.validFromDt = ReviewCommissionsService.toDate(row.valid_from_dt) ?? undefined;
    }
    if (row.valid_to_dt) {
      this.reviewCommissionsModel.validToDt = ReviewCommissionsService.toDate(row.valid_to_dt) ?? undefined;
    }
    this.persistSessionState();
  }

  /**
   * Currency symbol override for the current plan (e.g. "J$" for JMD), or undefined for
   * USD. Used by the template to normalize per-row money cells so they match the
   * client-formatted totals row (which applies the same override in calculateTotals).
   */
  get planCurrencySymbolOverride(): string | undefined {
    return getCurrencyInfo(this.reviewCommissionsModel?.country, this.reviewCommissionsModel?.salesChannel)
      .symbolOverride;
  }

  calculateTotals(queryData: any, filteredHeadersData: any): { totals: string[]; showHideTds: boolean[] } {

    //console.log(this.reviewCommissionsModel.salesChannel);
    const currencyInfo = getCurrencyInfo(this.reviewCommissionsModel.country, this.reviewCommissionsModel.salesChannel);
    let currencySymbol: any = currencyInfo.code;

    const locale = "en-US";
    const currencyFormatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencySymbol
    });

    this.showHideTds = [];
    const formattedTotals: string[] = [];
    const showHideTds: boolean[] = [];

    for (let i = 0; i < filteredHeadersData.length; i++) {
      const val = filteredHeadersData[i];
      const isTotalColumn = this.isTotalViewEnabled(val.istotalview);

      this.showHideTds[i] = !isTotalColumn;
      showHideTds[i] = !isTotalColumn;

      if (isTotalColumn) {
        // console.log(val.datakey);

        let key;

        // Check first letter
        const firstLetter = val.datakey.charAt(0);

        if (firstLetter === "m") {
          key = val.datakey.slice(1);
        } else {
          key = val.datakey;
        }


        const total = queryData?.reduce((sum, item) => sum + Number(item[key] || 0), 0) ?? 0;

        if (firstLetter === "m") {
          formattedTotals[i] = currencyFormatter.format(Number(total.toFixed(2)));
          // J$ follows the plan country (HOA-8305): symbolOverride is set when the resolved
          // currency is JMD, whether that came from country='JM' or the legacy salesChannel.
          if (currencyInfo.symbolOverride) {
            formattedTotals[i] = formattedTotals[i].replace(currencyInfo.code, currencyInfo.symbolOverride);
          }
        } else {
          formattedTotals[i] = total.toFixed(2);
        }

      } else {
        formattedTotals[i] = "";
      }

    }

    return { totals: formattedTotals, showHideTds };
  }

  isTotalViewEnabled(value: any): boolean {
    return this.isFlagEnabled(value);
  }

  isFlagEnabled(value: any): boolean {
    if (value === true || value === 1) {
      return true;
    }
    if (value === false || value === 0 || value == null) {
      return false;
    }
    return String(value).toLowerCase() === 'true';
  }

  hasTotalRow(res: ResponseData): boolean {
    if (!res?.headers?.length) {
      return false;
    }
    return res.headers.some((header) => this.isTotalViewEnabled(header.istotalview));
  }

  shouldShowTotalsForGrid(isLast: boolean): boolean {
    return this.pageName !== 'ListKPIs' || isLast;
  }

  isTotalValueHidden(res: ResponseData, index: number): boolean {
    return !!(res.showHideTds && res.showHideTds[index]);
  }

  isHeaderRightAligned(header: UpdateCommissionsUiModel | null | undefined): boolean {
    const alignment = (header?.margin || (header as any)?.position || '').trim().toLowerCase();
    return alignment === 'right';
  }

  hasDisputeColumn(res: ResponseData): boolean {
    if (!this.isDisputeBtnDisabled || !res?.headers?.length) {
      return false;
    }
    return res.headers.some((header) => this.isFlagEnabled(header.isdisputeview));
  }

  getTotalColspan(res: ResponseData): number {
    const colspan = Number(res.headers[0]?.colspancnt);
    if (colspan > 0) {
      return colspan;
    }
    const firstTotalIndex = res.headers?.findIndex((header) => this.isTotalViewEnabled(header.istotalview)) ?? -1;
    return firstTotalIndex > 0 ? firstTotalIndex : 1;
  }

  public getActiveKpis(): void {

    this.commissionSummaryService.getKpiActiveList(this.onClickedComplanId, localStorage.getItem('validToDt')).subscribe(
      (response: Kpimaster[]) => {
        this.kpis = response;
        this.filterKPiData = this.kpis;
      }, (errorResponse: HttpErrorResponse) => {
        this.notificationService.sendNotification(
          NotificationType.ERROR,
          ReviewCommissionsService.extractHttpErrorMessage(errorResponse)
        );
      }
    )
  }

  addMissingDispute(btn: any) {

    this.clickButton(btn);
  }

  displayCommissionPlanMeasureTypes(btn: any) {
    this.getImage();
    this.clickButton(btn);
  }

  getImage() {
    this.commissionService.getImage(this.onClickedComplanId, localStorage.getItem('SESSION_EFFDATE'))
      .subscribe((data: CommPlanDetail[]) => {
        this.getImageData = data;

        for (let imgData of this.getImageData) {
          this.imgStr = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,'
            + encodeURI(imgData.comm_img_str));
        }

      }, (errorResponse: HttpErrorResponse) => {
        this.notificationService.sendNotification(
          NotificationType.ERROR,
          ReviewCommissionsService.extractHttpErrorMessage(errorResponse)
        );
      });
  }

  hideRemainingLabels(id: number): boolean {
    if (id === 0)
      return true;
    else
      return false;
  }

  addNewRow(missingForm: NgForm) {
    const kpiObj = new MissingDisputesModel();
    kpiObj.kpi_id = this.missingDisputesModel1.kpi_id;
    kpiObj.comm_plan_id = this.missingDisputesModel1.comm_plan_id;
    this.missingModels.push(kpiObj);
  }

  public removeRow(index: any) {
    if (this.missingModels.length > 1) {
      if (this.missingModels[index].kpi_id != null) {
        this.removeFilterData(index);
      } else {
        this.removeFilterData(index);
      }
    } else {
      this.notificationService.sendNotification(NotificationType.WARNING, "There Is Only One Row Exist You Can't Delete.");
    }
  }

  private removeFilterData(i: any) {

    if (this.missingModels.length > 0) {
      const compos = this.missingModels[i].kpi_id;
      this.missingModels.forEach((value: any, index: any) => {
        if (value.kpi_id == compos)
          this.missingModels.splice(index, 1);
      })
    }
  }

  filterData(value: any) {
    this.selectedMIssingDisputeVal = value;
    if (value === "f") {
      this.isFixedDisabled = true;
      this.isMobileDisabled = false;
    } else {
      this.isFixedDisabled = false;
      this.isMobileDisabled = true;
    }
  }

  getViewDisputeValues(resData: any) {
    this.view_dscempid = resData.sc_emp_id;
    this.view_dcorp = resData.corp;
    this.view_dhouse = resData.house;
    this.view_dcust = resData.cust;
    this.view_dkomfeedid = resData.kom_feed_id;
    this.view_daccnum = resData.account_number;

    if (!this.view_dkomfeedid) {
      this.view_dtrackid = this.view_daccnum;
    } else {
      this.view_dtrackid = this.view_dkomfeedid;
    }

    if (!this.view_dtrackid) {
      this.view_dtrackid = this.view_dhouse;
    }

    this.approvalFlowService.getContentMessage(this.view_dtrackid)
      .subscribe((response: WorkFlowMessageModel) => {
        this.contentMessage = response;
        if (!this.contentMessage?.length || !this.contentMessage[0]?.message_content) {
          this.notificationService.sendNotification(NotificationType.ERROR, 'Dispute message not found');
          return;
        }

        this.contentMsgData = this.parseXmlToJson(this.contentMessage[0].message_content);
        this.displayedColumns = Object.keys(this.contentMsgData).map(k => k);
        this.displayedData = Object.values(this.contentMsgData).map(k => k);

        let j: number = 0;

        for (let msg of this.displayedData) {
          if (this.displayedData.length === 8) {
            if (j === 6) {
              this.disputeViewData = msg;
            }
            if (j === 7) {
              this.disputeViewKpiData = msg;
            }
          } else {
            if (j === 10) {
              this.disputeViewKpiData = msg;
            }
            if (j === 11) {
              this.disputeViewData = msg;
            }
          }

          j++;
        }
      }, (errorResponse: HttpErrorResponse) => {
        this.notificationService.sendNotification(
          NotificationType.ERROR,
          ReviewCommissionsService.extractHttpErrorMessage(errorResponse)
        );
      });
  }

  parseXmlToJson(xml) {
    const json = {};
    for (const res of xml.matchAll(/(?:<(\w*)(?:\s[^>]*)*>)((?:(?!<\1).)*)(?:<\/\1>)|<(\w*)(?:\s*)*\/>/gm)) {
      const key = res[1] || res[3];
      const value = res[2] && this.parseXmlToJson(res[2]);
      json[key] = ((value && Object.keys(value).length) ? value : res[2]) || null;
    }
    return json;
  }


  getAddDisputeValues(resData: any) {

    const model = this.reviewCommissionsModel;
    this.kpiid = resData.kpi_id ?? model?.kpi_id;
    this.dependent_kpiid = resData.dpndnt_kpi_id ?? model?.dpndnt_kpi_id ?? model?.dependentKpiId;
    if (this.dependent_kpiid) {
      this.final_kpiid = this.dependent_kpiid;
    } else {
      this.final_kpiid = this.kpiid;
    }
    this.sc_emp_id = resData.sc_emp_id;

    this.corp = resData.corp;
    this.house = resData.house;
    this.cust = resData.cust;
    this.kom_feed_id = resData.kom_feed_id;
    this.acc_num = resData.account_number;
    this.mobfeedid = resData.mob_feed_id;

    if (resData.account_number) {
      this.recordType = "mob";
      this.disputeMsg = "<DisputeType>Dispute-Mobile</DisputeType>" + "<FinalizedDate>-</FinalizedDate>" + "<AccountNumber>" + resData.account_number + "</AccountNumber>";

    } else if (resData.kom_feed_id) {
      this.recordType = "fixed";
      this.disputeMsg = "<Corp>" + resData.corp + "</Corp>"
        + "<House>" + resData.house + "</House>" + "<CustomerName>" + resData.cust_name + "</CustomerName>" + "<CompasID>" + resData.sc_emp_id + "</CompasID>"
        + "<Revenue>" + resData.net_revenue + "</Revenue>" + "<WorDate>" + resData.wordate + "</WorDate>"
        + "<WfinDate>" + resData.wfindate + "</WfinDate>";
    } else {
      this.recordType = "manual";
      this.disputeMsg = "<Corp>" + resData.corp + "</Corp>"
        + "<House>" + resData.house + "</House>" + "<CustomerName>" + resData.cust_name + "</CustomerName>" + "<CompasID>" + resData.sc_emp_id + "</CompasID>"
        + "<Revenue>" + resData.net_revenue + "</Revenue>" + "<WorDate>" + resData.wordate + "</WorDate>"
        + "<WfinDate>" + resData.wfindate + "</WfinDate>";
    }
  }

  public insertDispute(disputeForm: NgForm): void {
    this.vkpiid = "";
    for (let val of this.missingModels) {
      this.vkpiid = this.vkpiid + val.kpi_id + ",";
    }
    this.vkpiid = this.vkpiid.replace(/,\s*$/, "");

    this.workFlowMessageModel.kpiid = this.vkpiid;
    this.workFlowMessageModel.sc_emp_id = this.sc_emp_id;
    this.workFlowMessageModel.complanid = this.onClickedComplanId;//this.selectedCommPlanId;
    this.workFlowMessageModel.complex_kpiid = this.final_kpiid;

    this.workFlowMessageModel.corp = this.corp;
    this.workFlowMessageModel.house = this.house;
    this.workFlowMessageModel.cust = this.cust;
    this.workFlowMessageModel.kom_feed_id = this.kom_feed_id;
    this.workFlowMessageModel.accnum = this.acc_num;
    this.workFlowMessageModel.mob_feed_id = this.mobfeedid
    this.workFlowMessageModel.sales_rep_id = "NA";

    this.workFlowMessageModel.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.workFlowMessageModel.employee_id = localStorage.getItem('CURRENT_EMPLOYEEID_SESSION');
    this.workFlowMessageModel.loggedin_role = localStorage.getItem('CURRENT_USERROLE_SESSION');


    if (this.recordType === "mob") {
      this.workFlowMessageModel.message_content = this.disputeMsg + "<Message>" + this.workFlowMessageModel.dispute + "</Message>" + "<KPIID>" + this.workFlowMessageModel.kpiid + "</KPIID>";
    } else if (this.recordType === "fixed") {
      this.workFlowMessageModel.message_content = this.disputeMsg + "<KPIID>" + this.workFlowMessageModel.kpiid + "</KPIID>" + "<Message>" + this.workFlowMessageModel.dispute + "</Message>" + "<DisputeType>Dispute-Fixed Lines</DisputeType>" + "<Cust>" + this.workFlowMessageModel.cust + "</Cust>";
    } else if (this.recordType === "manual") {
      this.workFlowMessageModel.message_content = this.disputeMsg + "<KPIID>" + this.workFlowMessageModel.kpiid + "</KPIID>" + "<Message>" + this.workFlowMessageModel.dispute + "</Message>" + "<DisputeType>Dispute-Fixed Lines-Manual</DisputeType>" + "<Cust>" + this.workFlowMessageModel.cust + "</Cust>";
    }


    this.workFlowMessageModel.recordType = this.recordType;


    this.commissionSummaryService.insertDispute(this.workFlowMessageModel).subscribe(
      (response: WorkFlowMessageModel) => {
        this.notificationService.sendNotification(NotificationType.SUCCESS, "Inserted Successfully\nTicket Created");

        this.invalidateDisputeCacheForTrackId(this.buildTrackIdFromDisputeModel());
        this.updateResponseList();
        this.clickButton('closeAddButton');
      }, (errorResponse: HttpErrorResponse) => {
        this.notificationService.sendNotification(
          NotificationType.ERROR,
          ReviewCommissionsService.extractHttpErrorMessage(errorResponse)
        );
      }
    )

  }

  public insertMissingDispute(kpiForm: NgForm): void {
    this.vkpiid = "";
    for (let val of this.missingModels) {
      this.vkpiid = this.vkpiid + val.kpi_id + ",";
    }

    this.vkpiid = this.vkpiid.replace(/,\s*$/, "");
    kpiForm.value.kpi_id = this.vkpiid;
    kpiForm.value.message = this.missingDisputesModel.message;
    kpiForm.value.sc_emp_id = this.searchEmpParm;
    kpiForm.value.calRunId = this.selectedCalRunId;


    this.showLoading = true;
    const formData = this.missingDisputesService.createMissingForm(kpiForm.value);

    this.workFlowMessageModel.kpiid = this.vkpiid;
    this.workFlowMessageModel.sc_emp_id = this.onClickedScempid;
    this.workFlowMessageModel.calRunId = this.onClickedCalrunid;
    this.workFlowMessageModel.complanid = this.onClickedComplanId;

    this.workFlowMessageModel.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.workFlowMessageModel.employee_id = localStorage.getItem('CURRENT_EMPLOYEEID_SESSION');
    this.workFlowMessageModel.loggedin_role = localStorage.getItem('CURRENT_USERROLE_SESSION');

    this.workFlowMessageModel.corp = this.missingDisputesModel.corp;
    this.workFlowMessageModel.house = this.missingDisputesModel.house;
    this.workFlowMessageModel.cust = this.missingDisputesModel.cust;
    this.workFlowMessageModel.cust_id = this.missingDisputesModel.cust_id;
    this.workFlowMessageModel.finalizeddate = this.missingDisputesModel.finalizeddate;
    this.workFlowMessageModel.accnumber = this.missingDisputesModel.accnumber;


    if (this.selectedMIssingDisputeVal === "f") {
      //Feed
      this.disputeMsg = "<Corp>" + this.missingDisputesModel.corp + "</Corp>"
        + "<House>" + this.missingDisputesModel.house + "</House>" + "<CustomerName>" + this.missingDisputesModel.cust_id + "</CustomerName>" +
        "<DisputeType>Missing Transaction-Fixed Lines</DisputeType>" + "<FinalizedDate>" + this.missingDisputesModel.finalizeddate + "</FinalizedDate>" + "<AccountNumber>-</AccountNumber>" + "<Message>" + this.missingDisputesModel.message + "</Message>" + "<KPIID>" + this.workFlowMessageModel.kpiid + "</KPIID>" + "<Cust>" + this.workFlowMessageModel.cust + "</Cust>";
    } else {
      //Mobile
      this.disputeMsg = "<DisputeType>Missing Transaction-Mobile</DisputeType>" + "<FinalizedDate>-</FinalizedDate>" + "<AccountNumber>" + this.missingDisputesModel.accnumber + "</AccountNumber>" + "<Message>" + this.missingDisputesModel.message + "</Message>" + "<KPIID>" + this.workFlowMessageModel.kpiid + "</KPIID>";
    }

    this.workFlowMessageModel.message_content = this.disputeMsg;

    this.addMissingDisputes.kpi_id = this.vkpiid;
    this.addMissingDisputes.message = this.missingDisputesModel.message;
    this.addMissingDisputes.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');

    //console.log(this.addMissingDisputes);

    this.missingDisputesService.insertMissingDisputeStatic(this.addMissingDisputes).subscribe(
      (response: CustomHttpRespone) => {
        this.clickButton('closeAddButton');
        this.insertDisputeMsg();
        kpiForm.reset();
        this.vkpiid = "";
        this.missingModels = [];

        this.missingDisputesModel.created_by = "";
        this.missingDisputesModel.created_dt = new Date();
        this.missingModels.push(this.missingDisputesModel);

        this.showLoading = false;
      }, (errorResponse: HttpErrorResponse) => {
        this.notificationService.sendNotification(
          NotificationType.ERROR,
          ReviewCommissionsService.extractHttpErrorMessage(errorResponse)
        );
        this.showLoading = false;
      }
    )
  }

  public insertDisputeMsg(): void {
    this.commissionSummaryService.insertDisputeStatic(this.workFlowMessageModel).subscribe(
      (response: WorkFlowMessageModel) => {
        this.notificationService.sendNotification(NotificationType.SUCCESS, "Inserted Successfully. Ticket Created");
      }, (errorResponse: HttpErrorResponse) => {
        this.notificationService.sendNotification(
          NotificationType.ERROR,
          ReviewCommissionsService.extractHttpErrorMessage(errorResponse)
        );
      }
    )
  }

  removeListKPIs(arr: any[], pageName: string): any[] {
    return arr.filter(obj =>
      !Object.keys(obj).some(key => key.includes(pageName))
    );
  }

  ExportToExcelListKpis(res: any, headers: any) {
    this.excelDataList = null;
    this.excelDataList = JSON.parse(JSON.stringify(res));
    for (let js of this.excelDataList) {
      delete js.isDisputeSubmitted;
      delete js.valid_from_dt;
      delete js.valid_to_dt;
      delete js.effective_date;
      delete js.colorcode;
      delete js.comm_plan_id;
      delete js.kpi_id;
      delete js.mcommission_val;
      delete js.mrevenue;
      delete js.sc_emp_id;
      delete js.tier;
      delete js.view_order;
      delete js.sno;
      delete js.finalConfigId;
      delete js.calcRunStatus;
      delete js.disputeCloseDateStatus;
      delete js.cal_run_id;
      delete js.ssno;
      delete js.mnet_revenue;
      delete js.mcommissionable_revenue;
    }

    this.dataForExcel = [];
    this.dataForExcelKeys = [];
    let reportData = null;

    // Normalize per-cell currency symbol (e.g. "$" -> "J$" for JMD plans) so the exported
    // spreadsheet matches what the grid shows. (HOA-8305 follow-up)
    const symbolOverride = this.planCurrencySymbolOverride;
    this.excelDataList.forEach((row: any) => {
      this.dataForExcel.push(Object.values(row).map((v: any) => applyCurrencySymbolOverride(v, symbolOverride)));
      this.dataForExcelKeys.push(Object.keys(row));
    });

    reportData = {
      title: 'ReviewCommissions',
      data: this.dataForExcel,
      headers: this.dataForExcelKeys[0]
    }
    this.exportExcelService.exportExcel(reportData);
  }

  private clickButton(buttonId: string): void {
    document.getElementById(buttonId).click();
  }

  public clickToCloseButton(buttonId: string, disputeForm: NgForm): void {
    document.getElementById(buttonId).click();
    disputeForm.reset();
  }


  sort(colName) {
    this.str1 = colName;
    let j = (this.responseList.length - 1);

    if (this.str1 === this.str2) {
      if (this.pageName === "ListKPIs") {
        this.responseList[j].responsedata.sort((a: any, b: any) => a[colName] < b[colName] ? -1 : 1);
      } else {
        this.responseList[0].responsedata.sort((a: any, b: any) => a[colName] < b[colName] ? -1 : 1);
      }
      this.str2 = "";
      this.str1 = "";
    } else {
      if (this.pageName === "ListKPIs") {
        this.responseList[j].responsedata.sort((a: any, b: any) => a[colName] > b[colName] ? -1 : 1);
      } else {
        this.responseList[0].responsedata.sort((a: any, b: any) => a[colName] > b[colName] ? -1 : 1);
      }
      this.str2 = this.str1;
      this.str1 = "";
    }
  }
}
